"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
Object.defineProperty(exports, "__esModule", { value: true });
var e_1, _a;
var revert_error_1 = require("../../revert_error");
// tslint:disable:max-classes-per-file
var AuthorizedAddressMismatchError = /** @class */ (function (_super) {
    __extends(AuthorizedAddressMismatchError, _super);
    function AuthorizedAddressMismatchError(authorized, target) {
        return _super.call(this, 'AuthorizedAddressMismatchError', 'AuthorizedAddressMismatchError(address authorized, address target)', {
            authorized: authorized,
            target: target,
        }) || this;
    }
    return AuthorizedAddressMismatchError;
}(revert_error_1.RevertError));
exports.AuthorizedAddressMismatchError = AuthorizedAddressMismatchError;
var IndexOutOfBoundsError = /** @class */ (function (_super) {
    __extends(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, len) {
        return _super.call(this, 'IndexOutOfBoundsError', 'IndexOutOfBoundsError(uint256 index, uint256 len)', { index: index, len: len }) || this;
    }
    return IndexOutOfBoundsError;
}(revert_error_1.RevertError));
exports.IndexOutOfBoundsError = IndexOutOfBoundsError;
var SenderNotAuthorizedError = /** @class */ (function (_super) {
    __extends(SenderNotAuthorizedError, _super);
    function SenderNotAuthorizedError(sender) {
        return _super.call(this, 'SenderNotAuthorizedError', 'SenderNotAuthorizedError(address sender)', { sender: sender }) || this;
    }
    return SenderNotAuthorizedError;
}(revert_error_1.RevertError));
exports.SenderNotAuthorizedError = SenderNotAuthorizedError;
var TargetAlreadyAuthorizedError = /** @class */ (function (_super) {
    __extends(TargetAlreadyAuthorizedError, _super);
    function TargetAlreadyAuthorizedError(target) {
        return _super.call(this, 'TargetAlreadyAuthorizedError', 'TargetAlreadyAuthorizedError(address target)', { target: target }) || this;
    }
    return TargetAlreadyAuthorizedError;
}(revert_error_1.RevertError));
exports.TargetAlreadyAuthorizedError = TargetAlreadyAuthorizedError;
var TargetNotAuthorizedError = /** @class */ (function (_super) {
    __extends(TargetNotAuthorizedError, _super);
    function TargetNotAuthorizedError(target) {
        return _super.call(this, 'TargetNotAuthorizedError', 'TargetNotAuthorizedError(address target)', { target: target }) || this;
    }
    return TargetNotAuthorizedError;
}(revert_error_1.RevertError));
exports.TargetNotAuthorizedError = TargetNotAuthorizedError;
var ZeroCantBeAuthorizedError = /** @class */ (function (_super) {
    __extends(ZeroCantBeAuthorizedError, _super);
    function ZeroCantBeAuthorizedError() {
        return _super.call(this, 'ZeroCantBeAuthorizedError', 'ZeroCantBeAuthorizedError()', {}) || this;
    }
    return ZeroCantBeAuthorizedError;
}(revert_error_1.RevertError));
exports.ZeroCantBeAuthorizedError = ZeroCantBeAuthorizedError;
var types = [
    AuthorizedAddressMismatchError,
    IndexOutOfBoundsError,
    SenderNotAuthorizedError,
    TargetAlreadyAuthorizedError,
    TargetNotAuthorizedError,
    ZeroCantBeAuthorizedError,
];
try {
    // Register the types we've defined.
    for (var types_1 = __values(types), types_1_1 = types_1.next(); !types_1_1.done; types_1_1 = types_1.next()) {
        var type = types_1_1.value;
        revert_error_1.RevertError.registerType(type);
    }
}
catch (e_1_1) { e_1 = { error: e_1_1 }; }
finally {
    try {
        if (types_1_1 && !types_1_1.done && (_a = types_1.return)) _a.call(types_1);
    }
    finally { if (e_1) throw e_1.error; }
}
//# sourceMappingURL=authorizable_revert_errors.js.map